import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableRow,IconButton } from "@material-ui/core";
import { ArrowBackSharp } from "@material-ui/icons";
import Loading from "./Loading";
import url from "../constants/URL";

export function Receipt(props) {
  const [loading, setLoading] = useState(true);
  const [receipt, setReceipt] = useState(null);

  async function fetchData() {
    let token = await JSON.parse(
        window.localStorage.getItem("persist:auth")
      ).token;
      
    fetch(`${url}/receipt/${props.match.params.orderId}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((receipt) => {
          if(receipt !== null){
            setReceipt(receipt);
          }
          setLoading(false);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Loading />;
  }

  if(!receipt){
      return(
          <h1>Order Not Found</h1>
      )
  }

  let sendAt_date = new Date(receipt.sendAt).toLocaleDateString();
  let receivedAt_date = new Date(receipt.receivedAt).toLocaleDateString();
  var total_quantity = 0;
    var total_price = 0;
  return (
    <div style={{ textAlign: "center" }}>
        <h3
          style={{
            color: "white",
            backgroundColor: "black",
            borderRadius: "20px",
            padding: "10px 0",
            margin: "10px 0",
          }}
        >
          Order Details
        </h3>

        <div
          style={{
            display: "inline-block",
            backgroundColor: "antiquewhite",
            borderRadius: "20px",
          }}
        >
          <Table className="table" size="small">
            <IconButton onClick={() => props.history.goBack()}>
              <ArrowBackSharp />
            </IconButton>
            <TableRow>
              <TableCell></TableCell>
              <TableCell className="bigDevices">
                <b>Order By</b>
              </TableCell>
              <TableCell numeric>
                <i>{receipt.buyer.name}</i>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}></TableCell>
              <TableCell className="bigDevices" style={{ border: "none" }}>
                <b>Order At</b>
              </TableCell>
              <TableCell numeric style={{ border: "none" }}>
                <i>{sendAt_date}</i>
              </TableCell>
              <TableCell style={{ border: "none" }}></TableCell>
            </TableRow>

            <TableRow>
              <TableCell></TableCell>
              <TableCell className="bigDevices">
                <b>Received At</b>
              </TableCell>
              <TableCell numeric>
                <i>{receivedAt_date}</i>
              </TableCell>
              <TableCell></TableCell>
            </TableRow>

            <TableRow>
              <TableCell></TableCell>
              <TableCell className="bigDevices">
                <b>Items</b>
              </TableCell>
              <TableCell numeric>
                <b>Quantity</b>
              </TableCell>
              <TableCell numeric>
                <b>Price</b>
              </TableCell>
            </TableRow>

            <TableBody>
              {receipt.order.map((order) => {
                const { item, quantity } = order;
                total_quantity = total_quantity + quantity;
                total_price = total_price + item.price * quantity;
                return (
                  <TableRow>
                    <TableCell style={{ border: "none" }}>
                      {/* <img
                        src={image}
                        style={{ width: "75px", borderRadius: "13%" }}
                        alt={"item img"}
                      /> */}
                    </TableCell>
                    <TableCell
                      component="th"
                      scope="row"
                      className="bigDevices"
                      style={{ border: "none" }}
                    >
                      {item.name}
                    </TableCell>
                    <TableCell numeric style={{ border: "none" }}>
                      {quantity}
                    </TableCell>
                    <TableCell numeric style={{ border: "none" }}>
                      {item.price}
                    </TableCell>
                  </TableRow>
                );
              })}

              <TableRow>
                <TableCell></TableCell>
                <TableCell component="th" scope="row" className="bigDevices">
                  <b>Subtotal</b>
                </TableCell>
                <TableCell numeric>
                  <b>{total_quantity}</b>
                </TableCell>
                <TableCell numeric>
                  <b>{total_price}</b>
                </TableCell>
              </TableRow>
            </TableBody>

            <TableRow>
              <TableCell style={{ border: "none" }}></TableCell>
              <TableCell className="bigDevices" style={{ border: "none" }}>
                <b>Delivery</b>
              </TableCell>
              <TableCell numeric style={{ border: "none" }}>
                <b>Distance</b>
              </TableCell>
              <TableCell numeric style={{ border: "none" }}>
                <b>Fee</b>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell></TableCell>
              <TableCell
                component="th"
                scope="row"
                className="bigDevices"
              ></TableCell>
              <TableCell numeric>
                <i>500 meters</i>
              </TableCell>
              <TableCell numeric>
                <>300/-</>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell style={{ border: "none" }}></TableCell>
              <TableCell className="bigDevices" style={{ border: "none" }}>
                <h3>Grand Total</h3>
              </TableCell>
              <TableCell numeric style={{ border: "none" }}></TableCell>
              <TableCell numeric style={{ border: "none" }}>
                <h3>{total_price + 300}</h3>
              </TableCell>
            </TableRow>
          </Table>
        </div>
      </div>
  );
}

export default Receipt;
